<template>
  <div class="g-sidenav-show" style="background-color: #f0f6ff;">
    <div class="min-height-300 bg-dark position-absolute w-100"></div>
    <main class="main-content position-relative border-radius-lg">
      <!-- Navbar -->
      <HeaderMenu></HeaderMenu>
      <!-- End Navbar -->
      
      <div class="container-fluid pt-6" style="min-height: 100vh;">
        <!-- Notificaciones -->
        <div v-for="(notification, index) in notifications" :key="index" 
             class="alert position-fixed top-0 end-0 m-3" 
             :class="notification.class" 
             role="alert" 
             style="color: white; z-index: 9999; max-width: 360px;">
          {{ notification.message }}
          <button style="font-size: small" 
                  type="button" 
                  class="btn-close" 
                  @click="closeNotification(index)"
                  aria-label="Close"></button>
        </div>

                 <!-- Contenido principal -->
         <div class="row">
           <!-- Columna izquierda - Tabla de listas -->
           <div class="col-5">
             <div class="card mb-4">
               <div class="card-header pb-0 d-flex align-items-center">
                 <h6>Listas</h6>
                 <button @click="nuevaLista" class="btn btn-primary btn-sm ms-auto">
                   <i class="fas fa-plus me-2"></i>Nueva Lista
                 </button>
               </div>
               <div class="card-body px-0 pt-0 pb-2">
                 <!-- Buscador -->
                 <div class="px-3 py-3 d-flex gap-2 align-items-center">
                   <input type="text" 
                          class="form-control" 
                          placeholder="Buscar lista..." 
                          v-model="searchLista" 
                          style="max-width: 100%; min-height: 38px;">
                 </div>
                 
                 <!-- Tabla de listas -->
                 <div class="table-responsive p-0">
                   <table class="table align-items-center mb-0">
                     <thead>
                       <tr>
                         <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Descripción</th>
                         <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Valores</th>
                       </tr>
                     </thead>
                     <tbody>
                       <tr v-for="lista in listasPaginadas" 
                           :key="lista.id" 
                           @click="seleccionarLista(lista)"
                           :class="{ 'table-active': listaSeleccionada?.id === lista.id }">
                         <td class="align-middle text-start">
                           <span class="text-secondary text-xs font-weight-bold">{{ lista.descripcion }}</span>
                         </td>
                         <td class="align-middle text-start">
                           <span class="text-secondary text-xs font-weight-bold">{{ lista.valores_count ?? lista.valores?.length ?? 0 }} valores</span>
                         </td>
                       </tr>
                     </tbody>
                   </table>
                 </div>

                 <!-- Paginación -->
                 <nav aria-label="Page navigation" v-if="totalListas > pageLength">
                   <ul class="pagination justify-content-center">
                     <li class="page-item" :class="{ disabled: currentPage === 1 }">
                       <button class="page-link" 
                               @click="changePage(currentPage - 1)" 
                               :disabled="currentPage === 1">
                         <i class="fa-solid fa-arrow-left"></i>
                       </button>
                     </li>
                     <li class="page-item" 
                         v-for="page in paginationRange" 
                         :key="'page_' + page">
                       <button class="page-link" 
                               @click="changePage(page)"
                               :style="{ 
                                 backgroundColor: page === currentPage ? 'black' : '', 
                                 color: page === currentPage ? 'white' : '' 
                               }">
                         {{ page }}
                       </button>
                     </li>
                     <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                       <button class="page-link" 
                               @click="changePage(currentPage + 1)" 
                               :disabled="currentPage === totalPages">
                         <i class="fa-solid fa-arrow-right"></i>
                       </button>
                     </li>
                   </ul>
                 </nav>
               </div>
             </div>
           </div>

                       <!-- Columna derecha - Detalles de la lista seleccionada -->
            <div class="col-7">
              <div class="card mb-4" v-if="listaSeleccionada">
                <div class="card-header pb-0 d-flex align-items-center">
                  <h6>DATOS LISTA</h6>
                  <div class="ms-auto">
                    <button class="btn btn-success btn-sm me-2" 
                            @click="abrirModalImportar"
                            :disabled="guardando">
                      <i class="fas fa-file-excel me-1"></i>
                      Importar
                    </button>
                    <button class="btn btn-primary btn-sm" 
                            @click="guardarListaSeleccionada"
                            :disabled="guardando">
                      <span v-if="guardando" class="spinner-border spinner-border-sm me-2" role="status"></span>
                      Guardar
                    </button>
                  </div>
                </div>
                <div class="card-body">
                  <!-- Formulario de edición -->
                  <div class="row mb-4">
                    <div class="col-12">
                      <h6 class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7">Descripción de la Lista</h6>
                      <input class="form-control" 
                             type="text" 
                             v-model="listaSeleccionada.descripcion"
                             placeholder="Ingrese la descripción de la lista"
                             :class="{ 'is-invalid': errores.descripcion }">
                      <div v-if="errores.descripcion" class="invalid-feedback">
                        {{ errores.descripcion }}
                      </div>
                    </div>
                  </div>

                  <!-- Sección de valores -->
                  <div class="row">
                    <div class="col-12">
                      <h6 class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 mb-3">
                        VALORES
                      </h6>
                      
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <span class="text-sm text-muted">{{ listaSeleccionada.valores?.length || 0 }} valores</span>
                        <div class="d-flex gap-2">
                          <button type="button" 
                                  class="btn btn-outline-primary btn-sm" 
                                  @click="agregarValorALista">
                            <i class="fas fa-plus me-1"></i>Añadir Valor
                          </button>
                          <button type="button" 
                                  class="btn btn-outline-danger btn-sm" 
                                  @click="abrirModalVaciarLista"
                                  :disabled="!listaSeleccionada.valores?.length">
                            <i class="fas fa-trash-alt me-1"></i>Vaciar Lista
                          </button>
                        </div>
                      </div>
                      
                      <div v-if="!listaSeleccionada.valores || listaSeleccionada.valores.length === 0" 
                           class="text-center py-4 text-muted">
                        <i class="fas fa-list-ul fa-2x mb-2"></i>
                        <p>No hay valores en esta lista</p>
                      </div>
                      
                      <div v-else class="valores-lista">
                        <div v-for="(valor, index) in listaSeleccionada.valores" 
                             :key="valor.id || index" 
                             class="valor-lista-item d-flex align-items-center justify-content-between p-3 mb-2">
                          <div class="d-flex align-items-center flex-grow-1 me-3">
                            <span class="badge bg-primary me-3">{{ index + 1 }}</span>
                            <input class="form-control" 
                                   type="text" 
                                   v-model="valor.descripcion"
                                   :placeholder="`Valor ${index + 1}`"
                                   :class="{ 'is-invalid': errores.valores && errores.valores[index] }">
                          </div>
                          <div class="d-flex gap-2">                            
                            <button @click="eliminarValorDeLista(valor)" class="btn btn-danger btn-sm">Eliminar</button>
                          </div>
                          <div v-if="errores.valores && errores.valores[index]" class="invalid-feedback d-block w-100 mt-1">
                            {{ errores.valores[index] }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Mensaje cuando no hay lista seleccionada -->
              <div class="card mb-4" v-else>
                <div class="card-body text-center py-5">
                  <i class="fas fa-list-ul fa-3x text-muted mb-3"></i>
                  <h6 class="text-muted">Selecciona una lista para ver sus detalles</h6>
                  <p class="text-muted small">Haz clic en cualquier lista de la tabla para ver su información completa</p>
                </div>
              </div>
            </div>
         </div>
      </div>

      <!-- Modal de formulario -->
      <div v-if="mostrarModalListaForm" class="modal fade show" tabindex="-1" style="display: block; background: rgba(0,0,0,0.3);">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ esEditando ? 'Editar Lista' : 'Nueva Lista' }}</h5>
              <button type="button" 
                      class="btn-close" 
                      data-bs-dismiss="modal" 
                      aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <!-- Formulario -->
              <div class="form-group mb-3">
                <label class="form-control-label">Descripción de la Lista</label>
                <input class="form-control" 
                       type="text" 
                       v-model="listaForm.descripcion"
                       placeholder="Ingrese la descripción de la lista"
                       :class="{ 'is-invalid': errores.descripcion }">
                <div v-if="errores.descripcion" class="invalid-feedback">
                  {{ errores.descripcion }}
                </div>
              </div>

              <!-- Valores de la lista -->
              <div class="form-group">
                <label class="form-control-label d-flex justify-content-between align-items-center">
                  Valores de la Lista
                  <button type="button" 
                          class="btn btn-outline-primary btn-sm" 
                          @click="agregarValor">
                    <i class="fas fa-plus me-1"></i>Añadir Valor
                  </button>
                </label>
                
                <div v-if="listaForm.valores.length === 0" class="text-center py-4 text-muted">
                  <i class="fas fa-list-ul fa-2x mb-2"></i>
                  <p>No hay valores en esta lista</p>
                </div>
                
                <div v-else class="valores-container">
                  <div v-for="(valor, index) in listaForm.valores" 
                       :key="index" 
                       class="valor-item d-flex align-items-center gap-2 mb-2">
                    <input class="form-control" 
                           type="text" 
                           v-model="valor.descripcion"
                           :placeholder="`Valor ${index + 1}`"
                           :class="{ 'is-invalid': errores.valores && errores.valores[index] }">
                    <button type="button" 
                            class="btn btn-outline-danger btn-sm" 
                            @click="eliminarValor(index)"
                            title="Eliminar valor">
                      <i class="fas fa-trash"></i>
                    </button>
                    <div v-if="errores.valores && errores.valores[index]" class="invalid-feedback d-block">
                      {{ errores.valores[index] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" 
                      class="btn btn-secondary" 
                      data-bs-dismiss="modal">
                Cancelar
              </button>
              <button type="button" 
                      class="btn btn-primary" 
                      @click="guardarLista"
                      :disabled="guardando">
                <span v-if="guardando" class="spinner-border spinner-border-sm me-2" role="status"></span>
                {{ esEditando ? 'Actualizar' : 'Crear' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal de confirmación -->
      <div v-if="mostrarModalConfirmacion" class="modal fade show" tabindex="-1" style="display: block; background: rgba(0,0,0,0.3);">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirmar Eliminación</h5>
              <button type="button" 
                      class="btn-close" 
                      data-bs-dismiss="modal" 
                      aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p>{{ mensajeConfirmacion }}</p>
              <p class="text-muted small">Esta acción no se puede deshacer.</p>
            </div>
            <div class="modal-footer">
              <button type="button" 
                      class="btn btn-secondary" 
                      data-bs-dismiss="modal"
                      :disabled="eliminando">
                Cancelar
              </button>
              <button type="button" 
                      class="btn btn-danger" 
                      @click="eliminarLista"
                      :disabled="eliminando">
                <span v-if="eliminando" class="spinner-border spinner-border-sm me-2" role="status"></span>
                Eliminar
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal confirmar vaciar lista -->
      <div v-if="mostrarModalVaciarLista" class="modal fade show" tabindex="-1" style="display: block; background: rgba(0,0,0,0.3);">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Vaciar lista</h5>
              <button type="button" 
                      class="btn-close" 
                      @click="cerrarModalVaciarLista"
                      aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p>¿Está seguro de que desea eliminar todos los valores de la lista <strong>"{{ listaSeleccionada?.descripcion }}"</strong>?</p>
              <p class="text-muted small">Esta acción no se puede deshacer.</p>
            </div>
            <div class="modal-footer">
              <button type="button" 
                      class="btn btn-secondary" 
                      @click="cerrarModalVaciarLista"
                      :disabled="vaciando">
                Cancelar
              </button>
              <button type="button" 
                      class="btn btn-danger" 
                      @click="confirmarVaciarLista"
                      :disabled="vaciando">
                <span v-if="vaciando" class="spinner-border spinner-border-sm me-2" role="status"></span>
                Vaciar lista
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal de importación -->
      <div v-if="mostrarModalImportar" class="modal fade show" tabindex="-1" style="display: block; background: rgba(0,0,0,0.3);">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Importar Valores desde Archivo</h5>
              <button type="button" 
                      class="btn-close" 
                      @click="cerrarModalImportar" 
                      aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label for="archivoImportar" class="form-label">Seleccionar archivo Excel o CSV</label>
                <input type="file" 
                       class="form-control" 
                       id="archivoImportar"
                       ref="archivoInput"
                       @change="seleccionarArchivo"
                       accept=".xlsx,.xls,.csv">
                <div class="form-text">
                  Formatos permitidos: Excel (.xlsx, .xls) o CSV (.csv). Máximo 5MB.
                  Los valores deben estar en la columna A, la primera fila se ignora.
                </div>
              </div>
              
              <!-- Resultado de la importación -->
              <div v-if="resultadoImportacion && resultadoImportacion.estadisticas" class="alert alert-info">
                <h6>Resultado de la Importación</h6>
                <ul class="mb-0">
                  <li><strong>Valores creados:</strong> {{ resultadoImportacion.estadisticas.valores_creados || 0 }}</li>
                  <li><strong>Duplicados encontrados:</strong> {{ resultadoImportacion.estadisticas.valores_duplicados || 0 }}</li>
                  <li><strong>Filas vacías:</strong> {{ resultadoImportacion.estadisticas.valores_vacios || 0 }}</li>
                  <li><strong>Total de filas procesadas:</strong> {{ resultadoImportacion.estadisticas.total_filas || 0 }}</li>
                </ul>
                
                <!-- Detalles de duplicados -->
                <div v-if="resultadoImportacion.detalles && resultadoImportacion.detalles.duplicados && resultadoImportacion.detalles.duplicados.length > 0" class="mt-3">
                  <h6 class="text-warning">Valores duplicados:</h6>
                  <ul class="small">
                    <li v-for="dup in resultadoImportacion.detalles.duplicados" :key="dup.fila">
                      Fila {{ dup.fila }}: "{{ dup.valor }}"
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" 
                      class="btn btn-secondary" 
                      @click="cerrarModalImportar"
                      :disabled="importando">
                Cerrar
              </button>
              <button type="button" 
                      class="btn btn-success" 
                      @click="importarValores"
                      :disabled="!archivoSeleccionado || importando">
                <span v-if="importando" class="spinner-border spinner-border-sm me-2" role="status"></span>
                <i v-else class="fas fa-upload me-1"></i>
                Importar Valores
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, watch } from 'vue';
import HeaderMenu from '@/components/HeaderMenu.vue';
import axiosInstance from '@/axios.js';

// Estado de la aplicación
const listas = ref([]);
const cargando = ref(false);
const guardando = ref(false);
const eliminando = ref(false);
const vaciando = ref(false);
const esEditando = ref(false);
const listaAEliminar = ref(null);
const listaSeleccionada = ref(null);

// Estado del formulario
const listaForm = reactive({
  id: null,
  descripcion: '',
  valores: []
});

// Estado de errores
const errores = reactive({
  descripcion: '',
  valores: []
});

// Estado de búsqueda y paginación
const searchLista = ref('');
const pageLength = ref(10);

// Estado de importación
const mostrarModalImportar = ref(false);
const archivoSeleccionado = ref(null);
const importando = ref(false);
const resultadoImportacion = ref(null);
const archivoInput = ref(null);
const currentPage = ref(1);

// Referencias a modales
const mostrarModalListaForm = ref(false);
const mostrarModalConfirmacion = ref(false);
const mostrarModalVaciarLista = ref(false);

// Computed properties
const listasFiltradas = computed(() => {
  // Asegurar que listas.value sea un array
  const listasArray = Array.isArray(listas.value) ? listas.value : [];
  
  if (!searchLista.value) return listasArray;
  
  const search = searchLista.value.toLowerCase();
  return listasArray.filter(lista => 
    lista.descripcion.toLowerCase().includes(search)
  );
});

const totalListas = computed(() => listasFiltradas.value.length);
const totalPages = computed(() => Math.ceil(totalListas.value / pageLength.value));

const paginationRange = computed(() => {
  const range = [];
  const delta = 2;
  const start = Math.max(1, currentPage.value - delta);
  const end = Math.min(totalPages.value, currentPage.value + delta);
  for (let i = start; i <= end; i++) range.push(i);
  return range;
});

const listasPaginadas = computed(() => {
  const start = (currentPage.value - 1) * pageLength.value;
  const end = start + pageLength.value;
  return listasFiltradas.value.slice(start, end);
});

const mensajeConfirmacion = computed(() => {
  return `¿Está seguro de que desea eliminar la lista "${listaAEliminar.value?.descripcion}"?`;
});

// Notificaciones
const notifications = ref([]);

const showNotification = (message, type) => {
  const notification = {
    message,
    class: type,
  };
  notifications.value.push(notification);

  setTimeout(() => {
    closeNotification(notifications.value.indexOf(notification));
  }, 3000);
};

const closeNotification = (index) => {
  notifications.value.splice(index, 1);
};

// Funciones de paginación
const changePage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
  }
};

// Funciones de carga de datos
const cargarListas = async () => {
  cargando.value = true;
  try {
    const response = await axiosInstance.get('/api/listas');
    listas.value = response.data.data;
  } catch (error) {
    console.error('Error al cargar listas:', error);
    showNotification('Error al cargar las listas', 'alert-danger');
  } finally {
    cargando.value = false;
  }
};

// Funciones del formulario
const nuevaLista = () => {
  esEditando.value = false;
  resetearFormulario();
  abrirModalFormulario();
};


const resetearFormulario = () => {
  listaForm.id = null;
  listaForm.descripcion = '';
  listaForm.valores = [];
  limpiarErrores();
};

const limpiarErrores = () => {
  errores.descripcion = '';
  errores.valores = [];
};

const validarFormulario = () => {
  limpiarErrores();
  let esValido = true;

  // Validar descripción
  if (!listaForm.descripcion.trim()) {
    errores.descripcion = 'La descripción es obligatoria';
    esValido = false;
  }

  // Validar valores
  if (listaForm.valores.length === 0) {
    errores.valores = ['Debe agregar al menos un valor'];
    esValido = false;
  } else {
    errores.valores = [];
    listaForm.valores.forEach((valor, index) => {
      if (!valor.descripcion.trim()) {
        errores.valores[index] = 'La descripción del valor es obligatoria';
        esValido = false;
      }
    });
  }

  return esValido;
};

const guardarLista = async () => {
  if (!validarFormulario()) return;

  guardando.value = true;
  try {
    const datos = {
      descripcion: listaForm.descripcion,
      valores: listaForm.valores.map(valor => ({
        ...(valor.id != null && valor.id !== '' && { id: valor.id }),
        descripcion: valor.descripcion
      }))
    };

    if (esEditando.value) {
      await axiosInstance.put(`/api/listas/${listaForm.id}`, datos);
      showNotification('Lista actualizada correctamente', 'alert-success');
    } else {
      await axiosInstance.post('/api/listas', datos);
      showNotification('Lista creada correctamente', 'alert-success');
    }

    cerrarModalFormulario();
    cargarListas();
  } catch (error) {
    console.error('Error al guardar lista:', error);
    showNotification('Error al guardar la lista', 'alert-danger');
  } finally {
    guardando.value = false;
  }
};

// Funciones de valores
const agregarValor = () => {
  listaForm.valores.push({
    id: null,
    descripcion: '',
    lista_id: listaForm.id
  });
};

const eliminarValor = (index) => {
  listaForm.valores.splice(index, 1);
};

const eliminarLista = async () => {
  if (!listaAEliminar.value) return;

  eliminando.value = true;
  try {
    await axiosInstance.delete(`/api/listas/${listaAEliminar.value.id}`);
    showNotification('Lista eliminada correctamente', 'alert-success');
    cerrarModalConfirmacion();
    cargarListas();
  } catch (error) {
    console.error('Error al eliminar lista:', error);
    showNotification('Error al eliminar la lista', 'alert-danger');
  } finally {
    eliminando.value = false;
  }
};

// Funciones de modales
const abrirModalFormulario = () => {
  mostrarModalListaForm.value = true;
};

const cerrarModalFormulario = () => {
  mostrarModalListaForm.value = false;
};


const cerrarModalConfirmacion = () => {
  mostrarModalConfirmacion.value = false;
  listaAEliminar.value = null;
};

// Funciones auxiliares
// const formatearFecha = (fechaStr) => {
//   if (!fechaStr) return '';
//   const fecha = new Date(fechaStr);
//   return fecha.toLocaleDateString('es-ES', {
//     day: '2-digit',
//     month: '2-digit',
//     year: 'numeric',
//     hour: '2-digit',
//     minute: '2-digit'
//   });
// };

const seleccionarLista = async (lista) => {
  listaSeleccionada.value = lista;
  
  // Cargar los valores de la lista si no están cargados
  if (!lista.valores || lista.valores.length === 0) {
    try {
      const response = await axiosInstance.get(`/api/listas/${lista.id}/valores`);
      listaSeleccionada.value.valores = response.data.data.lista.valores || [];
    } catch (error) {
      console.error('Error al cargar valores:', error);
      showNotification('Error al cargar los valores de la lista', 'alert-danger');
    }
  }
};

const eliminarValorDeLista = (valor) => {
  if (!listaSeleccionada.value) return;
  
  // Remover el valor de la lista local
  const index = listaSeleccionada.value.valores.findIndex(v => v.id === valor.id);
  if (index > -1) {
    listaSeleccionada.value.valores.splice(index, 1);
  }
  
  // Actualizar también en la lista principal
  const listaIndex = listas.value.findIndex(l => l.id === listaSeleccionada.value.id);
  if (listaIndex > -1) {
    listas.value[listaIndex].valores = listaSeleccionada.value.valores;
  }
};

const agregarValorALista = () => {
  if (!listaSeleccionada.value) return;
  
  if (!listaSeleccionada.value.valores) {
    listaSeleccionada.value.valores = [];
  }
  
  listaSeleccionada.value.valores.push({
    id: null,
    descripcion: '',
    lista_id: listaSeleccionada.value.id
  });
};

const abrirModalVaciarLista = () => {
  mostrarModalVaciarLista.value = true;
};

const cerrarModalVaciarLista = () => {
  if (!vaciando.value) {
    mostrarModalVaciarLista.value = false;
  }
};

const confirmarVaciarLista = async () => {
  if (!listaSeleccionada.value) return;
  vaciando.value = true;
  try {
    // Vaciar solo en el front
    listaSeleccionada.value.valores = [];
    const listaIndex = listas.value.findIndex(l => l.id === listaSeleccionada.value.id);
    if (listaIndex > -1) {
      listas.value[listaIndex].valores = [];
    }
    // Llamar a la misma URL que el botón Guardar
    await guardarListaSeleccionada(true);
    mostrarModalVaciarLista.value = false;
    showNotification('Lista vaciada correctamente', 'alert-success');
  } catch (error) {
    console.error('Error al vaciar la lista:', error);
    showNotification('Error al vaciar la lista', 'alert-danger');
  } finally {
    vaciando.value = false;
  }
};

const validarListaSeleccionada = () => {
  limpiarErrores();
  let esValido = true;

  // Validar descripción
  if (!listaSeleccionada.value.descripcion.trim()) {
    errores.descripcion = 'La descripción es obligatoria';
    esValido = false;
  }

  // Validar valores
  if (!listaSeleccionada.value.valores || listaSeleccionada.value.valores.length === 0) {
    errores.valores = ['Debe agregar al menos un valor'];
    esValido = false;
  } else {
    errores.valores = [];
    listaSeleccionada.value.valores.forEach((valor, index) => {
      if (!valor.descripcion.trim()) {
        errores.valores[index] = 'La descripción del valor es obligatoria';
        esValido = false;
      }
    });
  }

  return esValido;
};

const guardarListaSeleccionada = async (allowEmptyValores = false) => {
  if (!listaSeleccionada.value) return;
  
  if (!allowEmptyValores && !validarListaSeleccionada()) return;

  guardando.value = true;
  try {
    const datos = {
      descripcion: listaSeleccionada.value.descripcion,
      valores: (listaSeleccionada.value.valores || []).map(valor => ({
        ...(valor.id != null && valor.id !== '' && { id: valor.id }),
        descripcion: valor.descripcion
      }))
    };

    await axiosInstance.put(`/api/listas/${listaSeleccionada.value.id}`, datos);
    
    // Actualizar también en la lista principal
    const listaIndex = listas.value.findIndex(l => l.id === listaSeleccionada.value.id);
    if (listaIndex > -1) {
      listas.value[listaIndex].descripcion = listaSeleccionada.value.descripcion;
      listas.value[listaIndex].valores = listaSeleccionada.value.valores;
    }
    
    showNotification('Lista actualizada correctamente', 'alert-success');
  } catch (error) {
    console.error('Error al guardar lista:', error);
    showNotification('Error al guardar la lista', 'alert-danger');
  } finally {
    guardando.value = false;
  }
};

// Funciones de importación
const abrirModalImportar = () => {
  mostrarModalImportar.value = true;
  resultadoImportacion.value = null;
  archivoSeleccionado.value = null;
  if (archivoInput.value) {
    archivoInput.value.value = '';
  }
};

const cerrarModalImportar = () => {
  mostrarModalImportar.value = false;
  resultadoImportacion.value = null;
  archivoSeleccionado.value = null;
  if (archivoInput.value) {
    archivoInput.value.value = '';
  }
};

const seleccionarArchivo = (event) => {
  const archivo = event.target.files[0];
  if (archivo) {
    // Validar tipo de archivo
    const tiposPermitidos = ['.xlsx', '.xls', '.csv'];
    const extension = archivo.name.toLowerCase().substring(archivo.name.lastIndexOf('.'));
    
    if (!tiposPermitidos.includes(extension)) {
      alert('Tipo de archivo no permitido. Use Excel (.xlsx, .xls) o CSV (.csv)');
      event.target.value = '';
      return;
    }
    
    // Validar tamaño (5MB)
    if (archivo.size > 5 * 1024 * 1024) {
      alert('El archivo es demasiado grande. Máximo 5MB');
      event.target.value = '';
      return;
    }
    
    archivoSeleccionado.value = archivo;
  } else {
    archivoSeleccionado.value = null;
  }
};

const importarValores = async () => {
  if (!archivoSeleccionado.value || !listaSeleccionada.value) return;
  
  importando.value = true;
  resultadoImportacion.value = null;
  
  try {
    const formData = new FormData();
    formData.append('archivo', archivoSeleccionado.value);
    
    const response = await axiosInstance.post(
      `/api/listas/${listaSeleccionada.value.id}/importar-valores`, 
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    
    resultadoImportacion.value = response.data;
    
    // Recargar la lista seleccionada para mostrar los nuevos valores
    await cargarListas();
    const listaActualizada = listas.value.find(l => l.id === listaSeleccionada.value.id);
    if (listaActualizada) {
      listaSeleccionada.value = listaActualizada;
    }
    
  } catch (error) {
    console.error('Error al importar valores:', error);
    if (error.response?.data?.message) {
      alert(`Error: ${error.response.data.message}`);
    } else {
      alert('Error al importar valores. Intente nuevamente.');
    }
  } finally {
    importando.value = false;
  }
};

// Watchers
watch(searchLista, () => {
  currentPage.value = 1;
});

// Lifecycle
onMounted(() => {
  cargarListas();
});
</script>

<style scoped>
/* Estilos para la paginación redonda */
.pagination .page-item .page-link {
  border-radius: 50% !important;
  width: 38px !important;
  height: 38px !important;
  min-width: 38px !important;
  min-height: 38px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  margin: 0 4px !important;
}

/* Estilos para las notificaciones */
.alert {
  z-index: 9999;
  max-width: 400px;
}

/* Estilos para la tabla */
.table tbody tr {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.table tbody tr.table-active {
  background-color: rgba(94, 114, 228, 0.1) !important;
  border-left: 3px solid #5e72e4;
}

/* Estilos para los botones de acción */
.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

/* Estilos para los valores de la lista */
.valores-container {
  max-height: 300px;
  overflow-y: auto;
}

.valor-item {
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.valor-item:hover {
  background-color: #e9ecef;
}

/* Estilos para los valores en detalle */
.valores-detalle {
  max-height: 400px;
  overflow-y: auto;
}

.valor-detalle-item {
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}

.valor-detalle-item:hover {
  background-color: #e9ecef;
  transform: translateX(2px);
}

.valor-detalle-item .badge {
  font-size: 0.75rem;
  padding: 0.5rem 0.75rem;
}

/* Estilos para los valores de la lista (similar a propiedades) */
.valores-lista {
  max-height: 400px;
  overflow-y: auto;
}

.valor-lista-item {
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
  margin-bottom: 8px;
}

.valor-lista-item:hover {
  background-color: #e9ecef;
  border-color: #5e72e4;
}

.valor-lista-item .badge {
  font-size: 0.75rem;
  padding: 0.5rem 0.75rem;
  min-width: 30px;
  text-align: center;
}

.valor-lista-item .form-control {
  border: none;
  background: transparent;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
}

.valor-lista-item .form-control:focus {
  border: 1px solid #5e72e4;
  background: white;
  box-shadow: 0 0 0 0.2rem rgba(94, 114, 228, 0.25);
}

/* Estilos para el modal */
.modal-lg {
  max-width: 800px;
}

/* Estilos para el formulario */
.form-control:focus {
  border-color: #5e72e4;
  box-shadow: 0 0 0 0.2rem rgba(94, 114, 228, 0.25);
}

.is-invalid {
  border-color: #dc3545;
}

.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}
</style>
